import {alpha} from '@mui/material'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import {indigo} from '@mui/material/colors'
import {CAward} from 'app/modules/discovery/core'
import {useStylesAwards} from 'styles/useStyles'
import SvgSbirSttrLogoIcon from './icons/Sbir_sttr_logo'

export default function AwardDataBox({award, padding}: {award: CAward; padding?: number}) {
  const classes = useStylesAwards()
  const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      justifyContent={'flex-start'}
      flexWrap={'wrap'}
      gap={2}
      justifyItems={'center'}
      alignItems={'center'}
      alignContent={'center'}
      sx={{backgroundColor: alpha(indigo[50], 0.3)}}
      mb={1}
      p={padding ? padding : 0}
    >
      {award.year && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Year
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.year}</Typography>
        </Box>
      )}
      {award.program && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Program
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.program}</Typography>
        </Box>
      )}
      {award.agency_name && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Agency
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.agency_name}</Typography>
        </Box>
      )}
      {award.agency_branch_name && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Agency Branch Name
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.agency_branch_name}</Typography>
        </Box>
      )}
      {award.phase && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            <SvgSbirSttrLogoIcon width={'80'} height={'80'} fs={'small'} /> Phase
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.phase}</Typography>
        </Box>
      )}
      {award.amount && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Amount
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{formatter.format(award.amount)}</Typography>
        </Box>
      )}

      {award.agency_tracking_number && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Tracking Number
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.agency_tracking_number}</Typography>
        </Box>
      )}

      {award.contract && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Contract
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.contract}</Typography>
        </Box>
      )}

      {award.topic_code && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Topic Code
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.topic_code}</Typography>
        </Box>
      )}
      {award.agency_branch_name && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Branch
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.agency_branch_name}</Typography>
        </Box>
      )}
      {award.solicitation_number && (
        <Box textAlign={'center'}>
          <Typography variant={'body1'} fontWeight={700}>
            Solicitation #
          </Typography>
          <Divider classes={{root: classes.indigoDivider}} />
          <Typography variant={'body2'}>{award.solicitation_number}</Typography>
        </Box>
      )}
    </Box>
  )
}
